export var affiliationTypeEnum = {
    PERMANENT: 'IND',
    TEMPORAL: 'TMP'
};

export var addressTypeEnum = {
    ADMINISTRATIVE: '01',
    COMMERCIAL: '02'
};

export var banks = {
    SCOTIABANK: '0012',
    BBVA: '0011'
};

export var currencyTypeEnum = {
    SOLES: '1',
    DOLARES: '2',
    SOLES_Y_DOLARES: '1-y-2'
};

export var jobReasonEnum = {
    INSTALACION: 'INS',
    REGISTRO: 'RGS'
};

export var subReasonsEnum = {
    NINGUNO: '0',
    MULTICOMERCIO_MISMO_RUC: 'MLR',
    MULTICOMERCIO: 'MLT'
};

export var tabletVisanetEnum = {
    // USER: 'AUTOAFILIACION',
    SERVICE_ID: 'N000010',
    CAPTURE_DEVICE_ID: 'N102000',
    CANAL_ID: '10'
};

export var pageEnum = {
    POS: 'pos',
    RUC: 'ruc',
    AFFILIATION_TYPE: 'affiliationType',
    LEGAL_REPRESENTATIVE_DATA: 'legalRepresentativeData',
    BUSINESS_DATA: 'businessData',
    ATTENTION_SCHEDULE: 'attentionSchedule',
    WANT_TO_CHARGE: 'wantToCharge',
    QUOTATION: 'quotation',
    QUOTATION_VIRTUAL: 'quotationVirtual',
    TERMS_AND_CONDITIONS: 'termsAndConditions',
    APP_DATA: 'appData',
    WEB_SITE_DATA: 'webSiteData',
    USER_DATA: 'userData'
};

export var virtualPosEnum = {
    PAGO_WEB: 'Pago Web',
    PAGO_LINK: 'Pago Link',
    PAGO_APP: 'Pago App'
};

export var presentialPosEnum = {
    POS_FIJO_INTERNET: 'POS fijo Internet',
    POS_FIJO_TELEFONICO: 'POS fijo telefónico',
    POS_INALAMBRICO: 'POS Inalámbrico',
    CORRESPONSALIA: 'Corresponsalía'
};

export var subProductEnum = {
    PAGO_WEB: 'CD',
    PAGO_LINK: 'PW',
    PAGO_APP: 'AP'
};

export var contactTypeEnum = {
    REPRESENTANTE_LEGAL: '01',
    CONTACTO: '02'
};

export var accountTypeEnum = {
    CORRIENTE: 'CCT',
    AHORROS: 'CAH'
};

export var solutionName = [{
    name: "POS",
    code: "BS",
    subCode: "BP"
}, {
    name: "Pago Link",
    code: "CE",
    subCode: "PW"
}, {
    name: "Pago Web",
    code: "CE",
    subCode: "CD"
}, {
    name: "Pago App",
    code: "CE",
    subCode: "AP"
}, {
    name: "CE/ PST",
    code: "CE",
    subCode: "PT"
}, {
    name: "CE/ Facilitador de Pagos",
    code: "CE",
    subCode: "FP"
}, {
    name: "Pago Programado",
    code: "RE",
    subCode: "RC"
}, {
    name: "Telepago",
    code: "MT",
    subCode: "UR"
}, {
    name: "QR",
    code: "CE",
    subCode: "QE"
}, {
    name: "QR integrado",
    code: "CE",
    subCode: "QD"
}];


//////////////////
// WEBPACK FOOTER
// ./src/enums.js
// module id = ./src/enums.js
// module chunks = 34